<script lang="ts" setup>
import GroupingDetailView from "@/views/airline_order/grouping/GroupingDetailView.vue";
definePage({
  meta: {
    action: "read",
    subject: "AirlineOrder",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <GroupingDetailView />
    </VCol>
  </VRow>
</template>

